module.exports = __webpack_public_path__ + "assets/marketo.5cf74bd3.svg";